import { defineComponent } from '@vue/composition-api';
import { useExperiment } from './useExperiment.js';

var script = defineComponent({
    setup: function () {
        var isLoadingExperiments = useExperiment().isLoadingExperiments;
        return {
            isLoadingExperiments: isLoadingExperiments,
        };
    },
});

export default script;
